// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./library/scss/style.scss
// module id = 3
// module chunks = 1